export const affiliates = [
  {"affiliate_id":"1","name":"(Testing) Behind the Markets"},
  {"affiliate_id":"2","name":"IMS"},
  {"affiliate_id":"3","name":"Pro Trading Research"},
  {"affiliate_id":"4","name":"It's Today Media"},
  {"affiliate_id":"5","name":"8020 Prosperity"},
  {"affiliate_id":"6","name":"St Paul Research"},
  {"affiliate_id":"7","name":"Musth.ca"},
  {"affiliate_id":"8","name":"Adam Mesh Media Group"},
  {"affiliate_id":"9","name":"Sandpiper Marketing"},
  {"affiliate_id":"10","name":"RevenueTree"},
  {"affiliate_id":"11","name":"Financial Traffic Network"},
  {"affiliate_id":"12","name":"Three Founders Publishing"},
  {"affiliate_id":"13","name":"Money Map Press"},
  {"affiliate_id":"14","name":"Banyan Hill"},
  {"affiliate_id":"15","name":"Paradigm Press"},
  {"affiliate_id":"16","name":"Millionaire Publishing"},
  {"affiliate_id":"17","name":"Meza Media"},
  {"affiliate_id":"18","name":"A4D BTM"},
  {"affiliate_id":"19","name":"Secco Squared"},
  {"affiliate_id":"20","name":"Mischeia"},
  {"affiliate_id":"21","name":"AdPrecise"},
  {"affiliate_id":"22","name":"CLM Media"},
  {"affiliate_id":"23","name":"Dedicated Emails"},
  {"affiliate_id":"24","name":"Stock Earnings"},
  {"affiliate_id":"25","name":"Barchart"},
  {"affiliate_id":"26","name":"BNK Invest"},
  {"affiliate_id":"27","name":"INO"},
  {"affiliate_id":"28","name":"Karmaholic Karma"},
  {"affiliate_id":"29","name":"Rightside Data"},
  {"affiliate_id":"30","name":"Trading Tips CTO"},
  {"affiliate_id":"31","name":"Schaeffers"},
  {"affiliate_id":"32","name":"Surefire Media Group, Inc"},
  {"affiliate_id":"33","name":"InvestingChannel"},
  {"affiliate_id":"34","name":"Market Movers Report"},
  {"affiliate_id":"35","name":"LeadMark"},
  {"affiliate_id":"36","name":"Investing Daily"},
  {"affiliate_id":"37","name":"Digiclicks"},
  {"affiliate_id":"38","name":"GBM Media Group"},
  {"affiliate_id":"39","name":"Crowdability"},
  {"affiliate_id":"40","name":"True Market Insiders"},
  {"affiliate_id":"41","name":"Strikepoint Media"},
  {"affiliate_id":"42","name":"Rainmaker"},
  {"affiliate_id":"43","name":"Conversion Pub"},
  {"affiliate_id":"44","name":"Darwin List Network"},
  {"affiliate_id":"45","name":"Financial Media Corporation"},
  {"affiliate_id":"46","name":"Sir Isaac Publishing"},
  {"affiliate_id":"47","name":"Benzinga"},
  {"affiliate_id":"48","name":"Kiplinger"},
  {"affiliate_id":"49","name":"UK Investor Mag"},
  {"affiliate_id":"50","name":"Falzon Marketing CPA"},
  {"affiliate_id":"51","name":"CJB"},
  {"affiliate_id":"52","name":"Rif.Marketing"},
  {"affiliate_id":"53","name":"(Network) YouTube - Viewability"},
  {"affiliate_id":"54","name":"FB"},
  {"affiliate_id":"55","name":"(Network) Google - Blue Land Partners"},
  {"affiliate_id":"56","name":"(Network) Bing"},
  {"affiliate_id":"57","name":"(Network) Yahoo Gemini - BTM Internal"},
  {"affiliate_id":"58","name":"Taboola"},
  {"affiliate_id":"59","name":"Outbrain"},
  {"affiliate_id":"60","name":"RevContent"},
  {"affiliate_id":"61","name":"Criteo"},
  {"affiliate_id":"62","name":"(Network) Dianomi - BTM Internal"},
  {"affiliate_id":"63","name":"Interactive Offers"},
  {"affiliate_id":"64","name":"Warrior Management"},
  {"affiliate_id":"65","name":"iDrive Interactive"},
  {"affiliate_id":"66","name":"ROIXY"},
  {"affiliate_id":"67","name":"Rival Brands"},
  {"affiliate_id":"68","name":"Mass1ve"},
  {"affiliate_id":"69","name":"Turtle Leads"},
  {"affiliate_id":"70","name":"Popular LLC"},
  {"affiliate_id":"71","name":"(Lead Gen) Behind The Markets"},
  {"affiliate_id":"72","name":"In Markets We Trust"},
  {"affiliate_id":"73","name":"BMF Financial Media"},
  {"affiliate_id":"74","name":"FXstreet"},
  {"affiliate_id":"75","name":"Consilience Financial"},
  {"affiliate_id":"76","name":"Benzinga"},
  {"affiliate_id":"77","name":"(Facebook) Blue Land Partners"},
  {"affiliate_id":"78","name":"The Horn News"},
  {"affiliate_id":"79","name":"EaglePub"},
  {"affiliate_id":"80","name":"Affiliati"},
  {"affiliate_id":"81","name":"(BTM) - Customer File"},
  {"affiliate_id":"82","name":"Finance & Investing Traffic, LLC"},
  {"affiliate_id":"83","name":"Dork Media LLC"},
  {"affiliate_id":"84","name":"gary neil"},
  {"affiliate_id":"85","name":"Link Media"},
  {"affiliate_id":"86","name":"Daily Trade Alert"},
  {"affiliate_id":"87","name":"(Network) Dianomi - ROI Marketplace"},
  {"affiliate_id":"88","name":"(Lead Gen) Adam Mesh"},
  {"affiliate_id":"89","name":"Beachside Inc."},
  {"affiliate_id":"90","name":"eMarket Media"},
  {"affiliate_id":"91","name":"Traffic Grid"},
  {"affiliate_id":"92","name":"(Lead Gen) PTR"},
  {"affiliate_id":"93","name":"(Email) Jeeng/PowerInbox - ROI Marketplace"},
  {"affiliate_id":"94","name":"Digital Alchemy"},
  {"affiliate_id":"95","name":"(CPC) It's Today Media"},
  {"affiliate_id":"96","name":"MarketBeat"},
  {"affiliate_id":"97","name":"Elijah List Publication"},
  {"affiliate_id":"98","name":"Tradeology"},
  {"affiliate_id":"99","name":"(Retargeting) Criteo - ROI Marketplace"},
  {"affiliate_id":"100","name":"BuyGoods"},
  {"affiliate_id":"101","name":"In Markets We Trust"},
  {"affiliate_id":"102","name":"Petkova & Kyufov LLC"},
  {"affiliate_id":"103","name":"4Ward Defense, LLC"},
  {"affiliate_id":"104","name":"(Network) Criteo - ROI Marketplace"},
  {"affiliate_id":"105","name":"Advertise Health Inc"},
  {"affiliate_id":"106","name":"(Lead Gen) PTR Test for Chase"},
  {"affiliate_id":"107","name":"Affiliate Moguls"},
  {"affiliate_id":"108","name":"(Network) Yahoo Gemini - ROI Marketplace"},
  {"affiliate_id":"109","name":"NewMarket Health"},
  {"affiliate_id":"110","name":"Oxford Club"},
  {"affiliate_id":"111","name":"Weiss Ratings"},
  {"affiliate_id":"112","name":"Traders Advertising"},
  {"affiliate_id":"113","name":"Oakie"},
  {"affiliate_id":"114","name":"(Lead Gen) Traders Advertising"},
  {"affiliate_id":"115","name":"(Lead Gen) IMS"},
  {"affiliate_id":"116","name":"(Lead Gen) After Offers"},
  {"affiliate_id":"117","name":"(Lead Gen) Rif Marketing"},
  {"affiliate_id":"118","name":"(Lead Gen) It's Today CTO"},
  {"affiliate_id":"119","name":"(Lead Gen) Trading Tips Co-Reg"},
  {"affiliate_id":"120","name":"(Lead Gen) Finance & Investing Traffic"},
  {"affiliate_id":"121","name":"(Lead Gen) PTR"},
  {"affiliate_id":"122","name":"(Network) Outbrain - ROI Marketplace"},
  {"affiliate_id":"123","name":"Earnings Whisper"},
  {"affiliate_id":"124","name":"(Lead Gen) MarketBeat CTO"},
  {"affiliate_id":"125","name":"none"},
  {"affiliate_id":"126","name":"(Lead Gen) Digital Alchemy"},
  {"affiliate_id":"127","name":"A. Dworkin MD PA"},
  {"affiliate_id":"128","name":"(Lead Gen) Sales Page Exit"},
  {"affiliate_id":"129","name":"(Lead Gen) Catch All"},
  {"affiliate_id":"130","name":"indivual"},
  {"affiliate_id":"131","name":"N/A"},
  {"affiliate_id":"132","name":"(Lead Gen) Financial Media Marketing"},
  {"affiliate_id":"133","name":"(Lead Gen) LeadMark"},
  {"affiliate_id":"134","name":"(Lead Gen) Musth"},
  {"affiliate_id":"135","name":"Profits Run"},
  {"affiliate_id":"136","name":"(Lead Gen) AdPrecise"},
  {"affiliate_id":"137","name":"(Lead Gen) JWRA"},
  {"affiliate_id":"138","name":"Decentral Publishing"},
  {"affiliate_id":"139","name":"(Lead Gen) Sandpiper CPL"},
  {"affiliate_id":"140","name":"JWRA"},
  {"affiliate_id":"141","name":"Revealed Films"},
  {"affiliate_id":"142","name":"(Lead Gen) Wallstreet.io"},
  {"affiliate_id":"143","name":"(Lead Gen) Darwin Co-Reg"},
  {"affiliate_id":"144","name":"(Lead Gen) Zenect"},
  {"affiliate_id":"145","name":"(Lead Gen) stocktickernews"},
  {"affiliate_id":"146","name":"(Lead Gen) LeadMark CTO"},
  {"affiliate_id":"147","name":"(Lead Gen) karmaholic"},
  {"affiliate_id":"148","name":"(Lead Gen) marketbeatcr"},
  {"affiliate_id":"149","name":"(Lead Gen)  GBM Media Group CTO"},
  {"affiliate_id":"150","name":"Stock Ideas"},
  {"affiliate_id":"151","name":"Zenect"},
  {"affiliate_id":"152","name":"(Lead Gen) trafficgrid"},
  {"affiliate_id":"153","name":"Investor Place"},
  {"affiliate_id":"154","name":"(Lead Gen) schaeffers"},
  {"affiliate_id":"155","name":"(Lead Gen) After Offers P4W"},
  {"affiliate_id":"156","name":"(Lead Gen) After Offers EOR"},
  {"affiliate_id":"157","name":"(Lead Gen) Digital Alchemy CTO"},
  {"affiliate_id":"158","name":"(Lead Gen) Interactive Offers CTO"},
  {"affiliate_id":"159","name":"test"},
  {"affiliate_id":"160","name":"(Lead Gen) KCBP"},
  {"affiliate_id":"161","name":"KCB Publishing"},
  {"affiliate_id":"162","name":"(Lead Gen) Interactive Offers Core"},
  {"affiliate_id":"163","name":"(Lead Gen) Vida Street"},
  {"affiliate_id":"164","name":"(CPC) IMS"},
  {"affiliate_id":"165","name":"Zacks"},
  {"affiliate_id":"166","name":"(Lead Gen) Stock Earnings CTO"},
  {"affiliate_id":"167","name":"(Lead Gen) 8020"},
  {"affiliate_id":"168","name":"(Lead Gen) Smart Coreg"},
  {"affiliate_id":"169","name":"Hyperion"},
  {"affiliate_id":"170","name":"Short Squeez"},
  {"affiliate_id":"171","name":"Magnetic Media Brokers"},
  {"affiliate_id":"172","name":"Partner X"},
  {"affiliate_id":"173","name":"FIT2"},
  {"affiliate_id":"174","name":"MediaPub"},
  {"affiliate_id":"175","name":"(Lead Gen) DirectMailersGroup"},
  {"affiliate_id":"176","name":"(Lead Gen) INO"},
  {"affiliate_id":"177","name":"Parler"},
  {"affiliate_id":"178","name":"Inside Wall Street"},
  {"affiliate_id":"179","name":"(LeadGen) Strikepoint"},
  {"affiliate_id":"180","name":"Yep Ads"},
  {"affiliate_id":"181","name":"Stonks"},
  {"affiliate_id":"182","name":"Best Stocks"},
  {"affiliate_id":"183","name":"(LeadGen) 406 Media"},
  {"affiliate_id":"184","name":"Rogue Investing"},
  {"affiliate_id":"185","name":"ModestMoney"},
  {"affiliate_id":"186","name":"(Lead Gen) Daily Guru Trades"},
  {"affiliate_id":"187","name":"International Living"},
  {"affiliate_id":"188","name":"Epoch Times"},
  {"affiliate_id":"189","name":"WealthPin"},
  {"affiliate_id":"190","name":"(Lead Gen) Money Map Press"},
  {"affiliate_id":"191","name":"AlphaShark"},
  {"affiliate_id":"192","name":"Red Hot MKT / Inactive "},
  {"affiliate_id":"193","name":"Clickbank"},
  {"affiliate_id":"194","name":"10XMedia"},
  {"affiliate_id":"195","name":"BTM: YouTube"},
  {"affiliate_id":"196","name":"TrafficGrid"},
  {"affiliate_id":"197","name":"BTM: Meta"},
  {"affiliate_id":"198","name":"Test partner"},
  {"affiliate_id":"199","name":"ROI Marketplace"},
  {"affiliate_id":"200","name":"OfferWave"},
  {"affiliate_id":"201","name":"Rountree Media Inc"},
  {"affiliate_id":"202","name":"Simply Digital Concepts"},
  {"affiliate_id":"203","name":"(Lead Gen - AT) Money Map Press"},
  {"affiliate_id":"204","name":"Andy Woods"},
  {"affiliate_id":"205","name":"(Lead Gen) Meta"},
  {"affiliate_id":"206","name":"(CPC) Strikepoint"},
  {"affiliate_id":"207","name":"(Lead Gen - AT) IMS"},
  {"affiliate_id":"208","name":"(Lead Gen - AT) After Offers"},
  {"affiliate_id":"209","name":"(Lead Gen - AT) Traders Advertising"},
  {"affiliate_id":"210","name":"Financial Media Marketing"},
  {"affiliate_id":"211","name":"(Lead Gen) Sparkloop"},
  {"affiliate_id":"212","name":"Sparkloop"},
  {"affiliate_id":"213","name":"(Lead Gen) Global Profit Systems"},
  {"affiliate_id":"214","name":"Global Profit Systems"},
  {"affiliate_id":"215","name":"Sovi Digital CTO"},
  {"affiliate_id":"216","name":"BTM: Opti"},
  {"affiliate_id":"217","name":"IMS (Display)"},
  {"affiliate_id":"218","name":"(Lead Gen) Behind The Markets - Meta"},
  {"affiliate_id":"219","name":"(Lead Gen) Behind The Markets - Bots"},
  {"affiliate_id":"220","name":"Angel Pub"},
  {"affiliate_id":"221","name":"Stansberry Research"},
  {"affiliate_id":"222","name":"Stock News"},
  {"affiliate_id":"223","name":"WealthPop"},
  {"affiliate_id":"224","name":"INDIVIDUAL"},
  {"affiliate_id":"225","name":"PilotHouse"},
  {"affiliate_id":"226","name":"(Lead Gen) Pilot House"},
  {"affiliate_id":"227","name":"(Lead Gen) ClickBank"},
  {"affiliate_id":"228","name":"(Lead Gen) Angel Pub"},
  {"affiliate_id":"229","name":"(Lead Gen) Falzon Marketing"},
  {"affiliate_id":"230","name":"Thunderclap Publishing"},
  {"affiliate_id":"231","name":"Falzon Marketing Pages"},
  {"affiliate_id":"232","name":"Evergreen Media Partners"},
  {"affiliate_id":"233","name":"Direct Mailers Group"},
  {"affiliate_id":"234","name":"Trade Thirsty"},
  {"affiliate_id":"235","name":"Code Funnels"},
  {"affiliate_id":"236","name":"(CPC) InvestingChannel"},
  {"affiliate_id":"237","name":"(Lead Gen) Radiant"},
  {"affiliate_id":"238","name":"Radiant Digital"},
  {"affiliate_id":"239","name":"Trilogy"},
  {"affiliate_id":"240","name":"(SMS) BTM - Customers"},
  {"affiliate_id":"241","name":"Morning Download"},
  {"affiliate_id":"242","name":"(Lead Gen) It's Today - Lead Share"},
  {"affiliate_id":"243","name":"After Offers"},
  {"affiliate_id":"244","name":"(Lead Gen) Eagle Pub"},
  {"affiliate_id":"245","name":"Reddit"},
  {"affiliate_id":"246","name":"(CPC) LeadMark"},
  {"affiliate_id":"247","name":"YouTube - Traffic Front"},
  {"affiliate_id":"248","name":"StoneForce Media"},
  {"affiliate_id":"249","name":" Breitbart"},
  {"affiliate_id":"250","name":"Taboola"},
  {"affiliate_id":"251","name":"(Lead Gen) Trading Tips CTO"},
  {"affiliate_id":"252","name":"(Lead Gen) It's Today (Coreg)"},
  {"affiliate_id":"253","name":"Capital Media"},
  {"affiliate_id":"254","name":"The Yellowbrick Road"},
  {"affiliate_id":"255","name":"LeadMark CTO"},
  {"affiliate_id":"256","name":"Stock Earnings CTO"},
  {"affiliate_id":"257","name":"Money Morning"},
  {"affiliate_id":"258","name":"(Lead Gen) CLM Media CTO"},
  {"affiliate_id":"259","name":"CLM Media CTO"},
  {"affiliate_id":"260","name":"(Lead Gen) Behind the Markets - Website Capture"},
  {"affiliate_id":"261","name":"(Lead Gen) Pro Trader Today"},
  {"affiliate_id":"262","name":"Pro Trader Today CTO"},
  {"affiliate_id":"263","name":"The Outsiders Club (NetEffect)"},
  {"affiliate_id":"264","name":"IMS CTO"},
  {"affiliate_id":"265","name":"Ghost Ventures USA"},
  {"affiliate_id":"266","name":"(Lead Gen) Ghost Ventures USA CTO"},
  {"affiliate_id":"267","name":" Pro Trader Today"},
  {"affiliate_id":"268","name":"(Lead Gen) DGT Website"},
  {"affiliate_id":"269","name":"Click Joy Media"},
  {"affiliate_id":"270","name":"MarketBeat CTO"},
  {"affiliate_id":"271","name":"(Lead Gen) Click Joy"},
  {"affiliate_id":"272","name":"The Daily Missive"},
  {"affiliate_id":"273","name":"Sellet"},
  {"affiliate_id":"274","name":"SurgeMail"},
  {"affiliate_id":"275","name":"Investors Expo (NetEffect)"},
  {"affiliate_id":"276","name":"Schaeffers (NetEffect)"},
  {"affiliate_id":"277","name":"Guardian Publishing"},
  {"affiliate_id":"278","name":"3rd Party Ad Sends"},
  {"affiliate_id":"279","name":"Investors Alley"},
  {"affiliate_id":"280","name":"(Lead Gen) Sovi Digital CTO"},
  {"affiliate_id":"281","name":"(Lead Gen) Sovi Digital (coreg)"},
  {"affiliate_id":"282","name":"ChartPrime"},
  {"affiliate_id":"283","name":"Alta Pub"},
  {"affiliate_id":"284","name":"The Trader Chick"},
  {"affiliate_id":"285","name":"Trading Strategy Guides"},
  {"affiliate_id":"286","name":"(Lead Gen) Fin MC CTO "},
  {"affiliate_id":"287","name":"Fin MC CTO"},
  {"affiliate_id":"288","name":"World Wide Digital "},
  {"affiliate_id":"289","name":"Trading Tips"},
  {"affiliate_id":"290","name":"Magnet Investing Insights"},
  {"affiliate_id":"291","name":"Smart Trading"},
  {"affiliate_id":"292","name":"Sovi Digital"},
  {"affiliate_id":"293","name":"Investment House"},
  {"affiliate_id":"294","name":"Traders Crux"},
  {"affiliate_id":"295","name":"Sales Agency"},
  {"affiliate_id":"296","name":"Vortex Media"},
  {"affiliate_id":"297","name":" (Lead Gen) Finance & Investing Traffic CTO"},
  {"affiliate_id":"298","name":"Finance & Investing Traffic CTO"},
  {"affiliate_id":"299","name":"NY Sun"},
  {"affiliate_id":"300","name":"Awesomely"},
  {"affiliate_id":"301","name":"JRWA"},
  {"affiliate_id":"302","name":"BTM Affiliate RFS (Network)"},
  {"affiliate_id":"303","name":" (Lead Gen) RFS Digital Media CPL"},
  {"affiliate_id":"304","name":"(Lead Gen) Click Joy 2"},
  {"affiliate_id":"305","name":"Freedom Financial Research LLC"},
  {"affiliate_id":"306","name":"BTM Affiliate"},
  {"affiliate_id":"307","name":"BTM Affiliate RFS"},
  {"affiliate_id":"308","name":"Investing Daily (NetEffect)"},
  {"affiliate_id":"309","name":"Alta Pub"},
  {"affiliate_id":"310","name":"Alta - InvestorPlace / TradeSmith"},
  {"affiliate_id":"311","name":"RFS Digital Media CPL"},
  {"affiliate_id":"312","name":"Stock Investor"},
  {"affiliate_id":"313","name":"Market Jar"},
  {"affiliate_id":"314","name":"Cash Cow (Billion Dollar Ads)"},
  {"affiliate_id":"315","name":"Mediaforce"},
  {"affiliate_id":"316","name":"It's Today CTO"},
  {"affiliate_id":"317","name":"Publisher Network"},
  {"affiliate_id":"318","name":"(Lead Gen) Hyperion CTO"},
  {"affiliate_id":"319","name":"Hyperion CTO"},
  {"affiliate_id":"320","name":"Old Brownstone Research"},
  {"affiliate_id":"321","name":"Brownstone Research"},
  {"affiliate_id":"322","name":"The Flyover"},
  {"affiliate_id":"323","name":" (Lead Gen) Stock Earnings CPL"},
  {"affiliate_id":"324","name":"Stock Earnings CPL"},
  {"affiliate_id":"325","name":"Behind the Markets - Fallback"},
  {"affiliate_id":"326","name":"Raging Bull"},
  {"affiliate_id":"327","name":"Gold Playbook"},
  {"affiliate_id":"328","name":" (Lead Gen) RFS Digital Media  CPL"},
  {"affiliate_id":"329","name":"RFS Digital Media  CPL"},
  {"affiliate_id":"330","name":"Stockguru"},
  {"affiliate_id":"331","name":"(Lead Gen) Karmaholic CTO"},
  {"affiliate_id":"332","name":"Karmaholic CTO"},
  {"affiliate_id":"333","name":"Prime Media"},
  {"affiliate_id":"334","name":"MediaForce"},
  {"affiliate_id":"335","name":"(Lead Gen) Darwin CTO "},
  {"affiliate_id":"336","name":"Darwin CTO "},
  {"affiliate_id":"337","name":"(Lead Gen) Stockguru CTO  "},
  {"affiliate_id":"338","name":"Stockguru CTO "},
  {"affiliate_id":"339","name":"Sandpiper CPL"},
  {"affiliate_id":"340","name":"GBM Media Group CTO "},
  {"affiliate_id":"341","name":"MediaGo (Network)"},
  {"affiliate_id":"342","name":"(Lead Gen) Market Jar "},
  {"affiliate_id":"343","name":"(Lead Gen) GBM Media Group Lead Share"},
  {"affiliate_id":"344","name":"Organic Growth USA"},
  {"affiliate_id":"345","name":"(Lead Gen) Hyperion Co-Reg"},
  {"affiliate_id":"346","name":"(Lead Gen) DIT Website"},
  {"affiliate_id":"347","name":"Capitol (NetEffect)"},
  {"affiliate_id":"348","name":"(Lead Gen) DWA Website"},
  {"affiliate_id":"349","name":"Golden Portfolio"},
  {"affiliate_id":"350","name":"Making Web"},
  {"affiliate_id":"351","name":"(Lead Gen) Trading Tips Custom CPC"},
  {"affiliate_id":"352","name":"Trading Tips Custom CPC"},
  {"affiliate_id":"353","name":"Mainstreet Alerts"},
  {"affiliate_id":"354","name":"(CPC) Trading Tips"},
  {"affiliate_id":"355","name":"Awareness Media Solutions"},
  {"affiliate_id":"356","name":"(CPC)  Musth"},
  {"affiliate_id":"357","name":"The Netwrk"},
  {"affiliate_id":"358","name":"Michael Hearne Live"},
  {"affiliate_id":"359","name":" (Lead Gen) Stock Earnings CoOp"},
  {"affiliate_id":"360","name":"Fragment Media Group"},
  {"affiliate_id":"361","name":"(CPC) Hyperion"},
  {"affiliate_id":"362","name":"Wellput"},
  {"affiliate_id":"363","name":"West Coast Media"},  
  {"affiliate_id":"368","name":"(Lead Gen) Marker Media"},
  {"affiliate_id":"372","name":"(Lead Gen) Dynamic Wealth Research"},
  {"affiliate_id":"374","name":"(Lead Gen) Guardian Publishing LeadShare"},  
  {"affiliate_id":"375","name":"(Lead Gen) Guardian Publishing CTO"},
  {"affiliate_id":"382","name":"(Lead Gen) BTM YouTube"},
  {"affiliate_id":"382","name":"(Lead Gen) Platoon CoReg"},  
  {"affiliate_id":"386","name":"(Lead Gen) Oxford Club Hotlist"},
  {"affiliate_id":"389","name":"(Lead Gen) Strikepoint Media CTO"}, 
  {"affiliate_id":"389","name":"(Lead Gen) Little Brook Media CoReg"},
  {"affiliate_id":"394","name":"(Lead Gen) Brownstone Hotlist"}, 
  {"affiliate_id":"395","name":"(Lead Gen) BTM 306 Hotlist"}, 
  {"affiliate_id":"397","name":"(Lead Gen) Hedge Accelerator CTO"}, 
  {"affiliate_id":"399","name":"(Lead Gen) Wall Street Zen"}, 
]